import { Box, Button, Fab, Portal } from '@mui/material';
import PropTypes from 'prop-types';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { OPEN_CHAT } from '../../../constants/strings';

const ChatButton = ({ disabled, onClick, container, buttonRef }) => {
  const isSmallScreen = useBreakpoint('sm');

  if (isSmallScreen) {
    return (
      <Box sx={{ px: 2, maxWidth: { sm: '500px' }, mx: 'auto' }}>
        <Button
          ref={buttonRef}
          variant='contained'
          fullWidth
          onClick={onClick}
          disabled={disabled}
        >
          {OPEN_CHAT}
        </Button>
      </Box>
    );
  }

  return (
    <Portal container={container}>
      <Fab
        ref={buttonRef}
        size='small'
        onClick={onClick}
        color='secondary'
        disabled={disabled}
      >
        <ChatOutlinedIcon />
      </Fab>
    </Portal>
  );
};

ChatButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  container: PropTypes.func,
  buttonRef: PropTypes.object,
};

export default ChatButton;
